import { newGuid } from '../../../../../helpers';
// @constants
export const DEFAULT_WIDTH_COLUMN = 80;
const $ = window.$;
/**
 * Wrapper with JQuery library
 * @param {DOM element} element
 */
// eslint-disable-next-line no-undef
export const getJQueryElement = (element) => $(element);

/**
 * Search a row in the table from any element, this row could be have information like ID or row expand data.
 * @param {DOM element} element - Any element inside the table (IgGrid).
 */
export const getParentRow = (element) => {
    const tagRowName = 'tr';
    let parent = null;
    let { parentNode } = element;

    while (parent === null) {
        if (parentNode.nodeName.toLowerCase() === tagRowName) {
            parent = parentNode;
        }

        parentNode = parentNode.parentNode;
    }
    return parent;
};

export const keyCode = {
    TAB: 9,
    ENTER: 13
};

export const summaryType = {
    CUSTOM: 'custom',
    SUM: 'sum'
};

export const widthType = {
    PERCENTAGE: '%',
    PIXEL: 'px'
};

/**
 * Parse number as decimal with decimals defined.
 * @param {number | string} value
 * @param {number} decimals
 */
const numberWithDecimal = (value, decimals = 2) => Number(`${Math.round(`${value}e+${decimals}`)}e-${decimals}`);

/**
 * @param {{
 *  id: string,
 *  fileName: string
 * }}
 */
// eslint-disable-next-line no-undef
export const exportToExcel = ({ id, fileName }) => $.ig.GridExcelExporter
    .exportGrid(getJQueryElement(`#${id}-table`), { fileName });

export const exportStationaryGrid = (workbook, fileName, sid,wid,hid,adjid,comid,acoid) => {
    const headerArr = [];
    // eslint-disable-next-line no-undef
    
        $.ig.GridExcelExporter
        .exportGrid(getJQueryElement(`#${sid}-table`),
            {
                fileName,
                worksheetName: 'Stationary',
                columnsToSkip: ['select', 'id', 'compositeKey'],
                gridFeatureOptions: { "sorting": "applied", "filtering": "applied", paging: "currentPage", "summaries": "applied" },
            },
            {
                headerCellExporting: (sender, args) => {
                    headerArr.push(args.headerText);
                    if (args.columnIndex === 0) {
                        sender._workbook = workbook;
                        sender._workbook.worksheets().add(sender._worksheet.name());
                        sender._worksheet = sender._workbook.worksheets(1);
                    }
                },
               
                exportEnding: (sender, args) => {
                    const row = sender._worksheet.rows(0);
                   headerArr.forEach((a, i) => {
                    row.setCellValue(i, a);
                    var headerCell = row.cells(i);
                    headerCell.cellFormat().fill(
                        $.ig.excel.CellFill.createSolidFill('rgb(136, 136, 136)')
                       );
                    });
                    /* eslint no-underscore-dangle: 0 */
                   exportWind_DrivenGrid(sender._workbook, wid,hid,adjid,comid,acoid, fileName);
                    return false;
                }
            });
       
};

export const exportWind_DrivenGrid = (workbook, wid,hid,adjid,comid,acoid, fileName) => {
    const headerArr = [];
    // eslint-disable-next-line no-undef
    $.ig.GridExcelExporter
        .exportGrid(getJQueryElement(`#${wid}-table`),
            {
                fileName,
                worksheetName: 'Wind Driven',
                columnsToSkip: ['select', 'id'],
                gridStyling: "none"
            },
            {
                headerCellExporting: (sender, args) => {
                    headerArr.push(args.headerText);
                    if (args.columnIndex === 0) {
                        sender._workbook = workbook;
                        sender._workbook.worksheets().add(sender._worksheet.name());
                        sender._worksheet = sender._workbook.worksheets(2);
                    }
                },
                exportEnding: (sender, args) => {
                    const row = sender._worksheet.rows(0);
                    headerArr.forEach((a, i) => {
                     row.setCellValue(i, a);
                     var headerCell = row.cells(i);
                     headerCell.cellFormat().fill(
                         $.ig.excel.CellFill.createSolidFill('rgb(136, 136, 136)')
                        );
                     });
                    exportHurricaneGrid(sender._workbook, hid,adjid,comid,acoid, fileName);
                    return false;
                }
            });
};
export const exportHurricaneGrid = (workbook, hid,adjid,comid,acoid, fileName) => {
    const headerArr = [];
    // eslint-disable-next-line no-undef
    $.ig.GridExcelExporter
        .exportGrid(getJQueryElement(`#${hid}-table`),
            {
                fileName,
                worksheetName: 'Hurricane',
                columnsToSkip: ['select', 'id'],
                gridStyling: "none"
            },
            {
                headerCellExporting: (sender, args) => {
                    headerArr.push(args.headerText);
                    if (args.columnIndex === 0) {
                        sender._workbook = workbook;
                        sender._workbook.worksheets().add(sender._worksheet.name());
                        sender._worksheet = sender._workbook.worksheets(3);
                    }
                },
                exportEnding: (sender, args) => {
                    const row = sender._worksheet.rows(0);
                    headerArr.forEach((a, i) => {
                     row.setCellValue(i, a);
                     var headerCell = row.cells(i);
                     headerCell.cellFormat().fill(
                         $.ig.excel.CellFill.createSolidFill('rgb(136, 136, 136)')
                        );
                     });
                    exportAdjustableGrid(sender._workbook, adjid,comid,acoid, fileName);
                    return false;
                }
            });
};
export const exportAdjustableGrid = (workbook, adjid,comid,acoid, fileName) => {
    const headerArr = [];
    // eslint-disable-next-line no-undef
    $.ig.GridExcelExporter
        .exportGrid(getJQueryElement(`#${adjid}-table`),
            {
                fileName,
                worksheetName: 'Adjustable',
                columnsToSkip: ['select', 'id'],
                gridStyling: "none"
            },
            {
                headerCellExporting: (sender, args) => {
                    headerArr.push(args.headerText);
                    if (args.columnIndex === 0) {
                        sender._workbook = workbook;
                        sender._workbook.worksheets().add(sender._worksheet.name());
                        sender._worksheet = sender._workbook.worksheets(4);
                    }
                },
                exportEnding: (sender, args) => {
                    const row = sender._worksheet.rows(0);
                    headerArr.forEach((a, i) => {
                     row.setCellValue(i, a);
                     var headerCell = row.cells(i);
                     headerCell.cellFormat().fill(
                         $.ig.excel.CellFill.createSolidFill('rgb(136, 136, 136)')
                        );
                     });
                    exportCombinationGrid(sender._workbook, comid,acoid, fileName);
                    return false;
                }
            });
};
export const exportCombinationGrid = (workbook, comid,acoid, fileName) => {
    const headerArr = [];
    // eslint-disable-next-line no-undef
    $.ig.GridExcelExporter
        .exportGrid(getJQueryElement(`#${comid}-table`),
            {
                fileName,
                worksheetName: 'Combination',
                columnsToSkip: ['select', 'id'],
                gridStyling: "none"
            },
            {
                headerCellExporting: (sender, args) => {
                    headerArr.push(args.headerText);
                    if (args.columnIndex === 0) {
                        sender._workbook = workbook;
                        sender._workbook.worksheets().add(sender._worksheet.name());
                        sender._worksheet = sender._workbook.worksheets(5);
                    }
                },
                exportEnding: (sender, args) => {
                    const row = sender._worksheet.rows(0);
                    headerArr.forEach((a, i) => {
                     row.setCellValue(i, a);
                     var headerCell = row.cells(i);
                     headerCell.cellFormat().fill(
                         $.ig.excel.CellFill.createSolidFill('rgb(136, 136, 136)')
                        );
                     });
                    exportAcousticalGrid(sender._workbook,acoid, fileName);
                    return false;
                }
            });
};
export const exportAcousticalGrid = (workbook,acoid, fileName) => {
    const headerArr = [];
    // eslint-disable-next-line no-undef
    $.ig.GridExcelExporter
        .exportGrid(getJQueryElement(`#${acoid}-table`),
            {
                fileName,
                worksheetName: 'Acoustical',
                columnsToSkip: ['select', 'id'],
                gridStyling: "none"
            },
            {
                headerCellExporting: (sender, args) => {
                    headerArr.push(args.headerText);
                    if (args.columnIndex === 0) {
                        sender._workbook = workbook;
                        sender._workbook.worksheets().add(sender._worksheet.name());
                        sender._worksheet = sender._workbook.worksheets(6);
                    }
                },
                exportEnding: (sender, args) => {
                    const row = sender._worksheet.rows(0);
                   headerArr.forEach((a, i) => {
                    row.setCellValue(i, a);
                    var headerCell = row.cells(i);
                    headerCell.cellFormat().fill(
                        $.ig.excel.CellFill.createSolidFill('rgb(136, 136, 136)')
                       );
                    });
                    //exportAcousticalGrid(sender._workbook, wid,hid,adjid,comid,acoid, fileName);
                    //return false;
                }
            });
};
export const exportScheduleGridToExcel = (
    {
        allId,sid,wid,hid,adjid,comid,acoid,
        fileName,
        accessoryArray
    }
) => {
    const headerArr = [];
    // eslint-disable-next-line no-undef
    $.ig.GridExcelExporter
        .exportGrid(getJQueryElement(`#${allId}-table`),
            {
                fileName,
                worksheetName: 'All',
                columnsToSkip: ['select', 'id'],
                gridStyling: "none"
                //tableStyle:"TableStyleLight"
            },
            
            {
                headerCellExporting: (sender, args) => {
                    headerArr.push(args.headerText);
                  },
                exportEnding: (e, args) => {
                    const row = e._worksheet.rows(0);
                    headerArr.forEach((a, i) => {
                     row.setCellValue(i, a);
                     var headerCell = row.cells(i);
                     headerCell.cellFormat().fill(
                         $.ig.excel.CellFill.createSolidFill('rgb(136, 136, 136)')
                        );
                     });
                   // Object.values(CATEGORY).map(cat => {
                    exportStationaryGrid(args.workbook,fileName,sid,wid,hid,adjid,comid,acoid);
                   //  })
                    return false;
                }

            });
};
/**
 * @param {DOM element} o 
 */
// eslint-disable-next-line no-undef
export const importExcel = (o, iData) => {
    let excelFile,
        fileReader = new FileReader();
    // $("#result").hide();
    fileReader.onload = function (e) {
        let buffer = new Uint8Array(fileReader.result);
        // eslint-disable-next-line no-undef
        $.ig.excel.Workbook.load(buffer, function (workbook) {
            let column, row, newRow, cellValue, columnIndex, i,
                worksheet = workbook.worksheets(0),
                columnsNumber = 0,
                gridColumns = [],
                data = [],
                worksheetRowsCount;

            // Both the columns and rows in the worksheet are lazily created and because of this most of the time worksheet.columns().count() will return 0
            // So to get the number of columns we read the values in the first row and count. When value is null we stop counting columns:
            while (worksheet.rows(0).getCellValue(columnsNumber)) {
                columnsNumber++;
            }

            // Iterating through cells in first row and use the cell text as key and header text for the grid columns
            for (columnIndex = 0; columnIndex < columnsNumber; columnIndex++) {
                column = worksheet.rows(0).getCellText(columnIndex);
                gridColumns.push({ headerText: column, key: getColumnKey(column) });
            }

            // We start iterating from 1, because we already read the first row to build the gridColumns array above
            // We use each cell value and add it to json array, which will be used as dataSource for the grid
            for (i = 1, worksheetRowsCount = worksheet.rows().count(); i < worksheetRowsCount; i++) {
                newRow = {};
                row = worksheet.rows(i);

                for (columnIndex = 0; columnIndex < columnsNumber; columnIndex++) {
                    cellValue = row.getCellText(columnIndex) === "N/A" ? "0" : row.getCellText(columnIndex);
                    newRow[gridColumns[columnIndex].key] = cellValue;
                    if (gridColumns[columnIndex].key === "model")
                        newRow.ModelName = cellValue;
                    if (gridColumns[columnIndex].key === "Class A 29 MPH Wind VEL (fpm)")
                        newRow.lowWeather = cellValue;
                    if (gridColumns[columnIndex].key === "Class A 50 MPH Wind VEL (fpm)")
                        newRow.highWeather = cellValue;
                    if (gridColumns[columnIndex].key === "Max Exhaust (fpm)")
                        newRow.maxExhVelFPM = cellValue;
                }
                newRow.id = newGuid();
                newRow.Brand = "Ruskin";

                data.push(newRow);
            }
            iData.current = data;
        }, function (error) {
            console.log('The excel file is corrupted.')
        });
    }

    if (o.target.files.length > 0) {
        excelFile = o.target.files[0];
        if (excelFile.type === "application/vnd.ms-excel" || excelFile.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" || (excelFile.type === "" && (excelFile.name.endsWith("xls") || excelFile.name.endsWith("xlsx")))) {
            fileReader.readAsArrayBuffer(excelFile);
        } else {
            console.log('The format of the file you have selected is not supported. Please select a valid Excel file (".xls, *.xlsx").');
        }
    }

};

const getColumnKey = (c) => {
    switch (c) {
        case 'Model':
            return 'model';
        case 'Product Type':
            return 'styleDescription';
        case 'Tag':
            return 'tag';
        case 'Quantity':
            return 'quantity';
        case 'Width (in.)':
            return 'selectedWidth';
        case 'Height (in.)':
            return 'selectedHeight';
        case 'Flow (CFM)':
            return 'selectedAirFlow';
        case 'Application':
            return 'selectedFlowDirection';
        case 'Free Area (ft²)':
            return 'freeArea';
        case 'Free Area %':
            return 'freeAreaPerc';
        case 'Free Area Vel (fpm)':
            return 'freeAreaVelocity';
        case 'Pressure Drop (in. wg)':
            return 'pressureDrop';
        case 'Beginning Water Pen. (fpm)':
            return 'begWaterPen';
        case 'Water Pen Safety Factor':
            return 'waterPenSafFac';
        case '29mph':
            return 'lowWeather';
        case '50mph':
            return 'highWeather';
        case 'Max Exhaust':
            return 'maxExhVelFPM';
        case 'Sect. Width':
            return 'width';
        case 'Sect. Height':
            return 'height';
        case 'Comment':
            return 'comment';
        case 'ID':
            return 'id';
        default:
            return c;
    }
};

/**
 * Custom filter handler (from Edge app), allow filter if column has datasource or decimals precision.
 * @param {{
 *  cond: {string},
 *  expr: {string},
 *  fieldName: {string}
 * }[]} fieldExpressions
 * @param {array} dataSource
 */
export const onIgDataSourceFiltering = ({ fieldExpressions, dataSource, columns }) => {
    if (!fieldExpressions) {
        return dataSource;
    }

    const data = fieldExpressions.reduce((accumulator, current) => {
        const { cond: condition, expr: expression, fieldName } = current;
        const column = columns.find((column) => column.key === fieldName);
        let filterPredicate;
        switch (condition) {
            case 'contains':
                const matchExpression = new RegExp(`${expression}`, 'i');
                filterPredicate = column.dataSource
                    ? (item) => {
                        const matches = column.dataSource.filter(
                            (columnItem) => column.textKey && columnItem[column.textKey].match(matchExpression)
                        );
                        return matches.some((match) => match[column.valueKey] === item[fieldName]);
                    } : (item) => item[fieldName] && item[fieldName].match(matchExpression);
                break;
            case 'equals':
                if (column.dataSource) {
                    filterPredicate = (item) => {
                        const matches = column.dataSource
                            .filter((columnItem) => column.textKey && columnItem[column.textKey] === expression);
                        return matches.some((match) => match[column.valueKey] === item[fieldName]);
                    };
                } else if (column.dataMode === 'double') {
                    filterPredicate = (item) => numberWithDecimal(item[fieldName]) === numberWithDecimal(expression);
                } else {
                    filterPredicate = (item) => item[fieldName] === expression;
                }
                break;
            default:
                break;
        }

        const items = filterPredicate ? dataSource.filter(filterPredicate) : dataSource;
        return [...accumulator, ...items];
    }, []);
    return data;
};

/**
 * Attach function to window object for what can access from DOM element.
 * @param {string} type
 * @param {function} callback
 */
export const registerGlobalHandler = (type, callback) => {
    window[type] = callback;
};

/**
 * @param {string} visibility - CSS visibility prop
 */
export const visibilityOfTooltips = (visibility) => {
    const tooltips = document.getElementsByClassName('ui-igpopover');
    Array.from(tooltips).forEach((tooltip) => {
        if (tooltip && tooltip.id.contains('tooltips_popover')) {
            tooltip.style.visibility = visibility;
        }
    });
};
